// Login.js
import React, { useState, useEffect } from 'react';
import Navigation from '../Navbar/Navbar';
import './Login.css';
import { Container, Card, Form, Button, Alert, Row, Col } from 'react-bootstrap';
import { PersonCircle, ShieldLock, PersonFillAdd } from 'react-bootstrap-icons';
import axios from 'axios';

const apiUrl = "/api";

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loginError, setLoginError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [hasUsers, setHasUsers] = useState(null);
  const [checkingUsers, setCheckingUsers] = useState(true);

  useEffect(() => {
    const checkUsers = async () => {
      try {
        const response = await axios.get(apiUrl + '/check-users');
        setHasUsers(response.data.hasUsers);
      } catch (error) {
        console.error('Error checking users:', error);
        // If we can't check, assume users exist to avoid breaking existing installations
        setHasUsers(true);
      } finally {
        setCheckingUsers(false);
      }
    };

    checkUsers();
  }, []);

  const handleLogin = async () => {
    if (!username.trim() || !password.trim()) {
      setLoginError('Please enter both username and password.');
      return;
    }

    setIsLoading(true);
    setLoginError('');

    try {
      const response = await axios.post(apiUrl + '/login', { username, password });

      if (response.data && response.data.user && response.data.user.tenant_id) {
        // Store JWT token and user info
        localStorage.setItem('token', response.data.token);
        localStorage.setItem('user', JSON.stringify(response.data.user));
        localStorage.setItem('selectedTenant', response.data.user.tenant_id.toString());
        window.location.href = '#/';
      } else {
        setLoginError('Login failed: Invalid user data returned.');
      }
    } catch (error) {
      console.error(error);
      setLoginError('Invalid username or password. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleLogin();
    }
  };

  return (
    <div className="login-page">
      <Navigation />
      <Container className="login-container">
        <Row className="justify-content-center align-items-center min-vh-100">
          <Col xs={12} sm={8} md={6} lg={4}>
            <Card className="login-card">
              <Card.Body className="p-4">
                <div className="text-center mb-4">
                  <div className="login-icon mb-3">
                    <ShieldLock size={48} />
                  </div>
                  <h3 className="login-title">Asset Hub</h3>
                  <p className="text-muted">Please sign in to continue</p>
                </div>

                {loginError && (
                  <Alert variant="danger" dismissible onClose={() => setLoginError('')}>
                    {loginError}
                  </Alert>
                )}

                <Form>
                  <Form.Group className="mb-3">
                    <Form.Label>Username</Form.Label>
                    <div className="input-group">
                      <span className="input-group-text">
                        <PersonCircle />
                      </span>
                      <Form.Control
                        type="text"
                        placeholder="Enter your username"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        onKeyPress={handleKeyPress}
                        disabled={isLoading}
                        className="form-control-lg"
                      />
                    </div>
                  </Form.Group>

                  <Form.Group className="mb-4">
                    <Form.Label>Password</Form.Label>
                    <div className="input-group">
                      <span className="input-group-text">
                        <ShieldLock />
                      </span>
                      <Form.Control
                        type="password"
                        placeholder="Enter your password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        onKeyPress={handleKeyPress}
                        disabled={isLoading}
                        className="form-control-lg"
                      />
                    </div>
                  </Form.Group>

                  <Button
                    variant="primary"
                    size="lg"
                    className="w-100 login-btn"
                    onClick={handleLogin}
                    disabled={isLoading}
                  >
                    {isLoading ? 'Signing in...' : 'Sign In'}
                  </Button>
                </Form>

                {!checkingUsers && !hasUsers && (
                  <div className="text-center mt-3">
                    <Button
                      variant="link"
                      className="p-0 text-decoration-none"
                      onClick={() => window.location.href = '#/register'}
                    >
                      <PersonFillAdd className="me-2" />
                      First Time Setup - Create Admin Account
                    </Button>
                  </div>
                )}

              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Login;
